import React, { useEffect } from "react";
import { SkyCard, SkyButton, SkyText } from "@skypointcloud/skypoint-ui";
import { AlertTriangle, Mail, ExternalLink } from "lucide-react";
import { ThemedLogo } from "./theme/ThemedLogo";

const InactivePlan = (): React.ReactElement => {
  useEffect(() => {
    document.body.classList.add("body-gray");
    return () => {
      document.body.classList.remove("body-gray");
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-neutral-100 dark:bg-muted">
      <div className="flex justify-center items-center flex-1 p-8">
        <SkyCard className="max-w-[560px] w-full p-12 text-center shadow-lg rounded-2xl bg-white dark:bg-card">
          <div className="mb-8">
            <ThemedLogo
              src="dist/img/skyPoint-logo-text-black.svg"
              darkSrc="dist/img/skyPoint-logo-text-white.svg"
              alt="Skypoint"
              className="h-12 mx-auto"
            />
          </div>

          <div className="flex justify-center mb-6">
            <AlertTriangle className="w-16 h-16 text-yellow-500" />
          </div>

          <SkyText className="text-2xl font-bold mb-4 text-neutral-900 dark:text-foreground block">
            Account Deactivated
          </SkyText>

          <SkyText className="mb-8 text-neutral-600 dark:text-muted-foreground leading-relaxed block">
            Your company's Skypoint account has been deactivated. You can easily reactivate your
            service by subscribing to a Skypoint Plan as a tenant administrator.
          </SkyText>

          <div className="flex flex-col gap-4 mb-8">
            <a
              href="https://skyhire.skypoint.ai/"
              target="_blank"
              rel="noreferrer"
            >
              <SkyButton
                appearance="primary"
                size="large"
                icon={ExternalLink}
                className="min-w-[200px]"
              >
                Reactivate Account
              </SkyButton>
            </a>
          </div>

          <div className="h-px bg-neutral-200 dark:bg-white/10 my-6" />

          <div className="flex flex-col items-center gap-3">
            <SkyText className="text-neutral-500 dark:text-muted-foreground text-sm">
              Need help?
            </SkyText>
            <a
              href="mailto:support@skypoint.ai"
              className="flex items-center gap-2 text-blue-600 dark:text-blue-400 hover:underline"
            >
              <Mail className="w-5 h-5" />
              support@skypoint.ai
            </a>
          </div>
        </SkyCard>
      </div>
      <footer className="p-4 px-8 text-center border-t border-neutral-200 dark:border-border bg-white dark:bg-card">
        <SkyText className="text-neutral-500 dark:text-muted-foreground text-xs">
          Copyright &copy; {new Date().getFullYear()}{" "}
          <a
            href="https://skypoint.ai"
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 dark:text-blue-400 hover:underline"
          >
            Skypoint Cloud, Inc.
          </a>
          . All rights reserved.
        </SkyText>
      </footer>
    </div>
  );
};

export default InactivePlan;
